import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["label", "inline", "error", "readOnly", "disabled", "required", "dateFormat", "initialStartDate", "initialEndDate", "startDate", "endDate", "showMandatoryIndicator", "fieldClassName", "shouldShowLabel", "shouldShowError"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import { DatePicker } from 'antd';
import Label from '../Label';
import styles from './input.module.scss';
import './dateinput.antd.scss';
var RangePicker = DatePicker.RangePicker;
var TDateInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TDateInput, _React$PureComponent);
  var _super = _createSuper(TDateInput);
  function TDateInput() {
    var _this;
    _classCallCheck(this, TDateInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      focus: false
    });
    _defineProperty(_assertThisInitialized(_this), "focusHandler", function () {
      var onFocus = _this.props.onFocus;
      onFocus();
      _this.setState({
        focus: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "blurHandler", function () {
      var onBlur = _this.props.onBlur;
      onBlur();
      _this.setState({
        focus: false
      });
    });
    return _this;
  }
  _createClass(TDateInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        inline = _this$props.inline,
        error = _this$props.error,
        readOnly = _this$props.readOnly,
        disabled = _this$props.disabled,
        required = _this$props.required,
        dateFormat = _this$props.dateFormat,
        initialStartDate = _this$props.initialStartDate,
        initialEndDate = _this$props.initialEndDate,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate,
        showMandatoryIndicator = _this$props.showMandatoryIndicator,
        fieldClassName = _this$props.fieldClassName,
        shouldShowLabel = _this$props.shouldShowLabel,
        shouldShowError = _this$props.shouldShowError,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var wrapperClass = fieldClassName;
      if (readOnly) {
        wrapperClass = cx(wrapperClass, styles.readOnly);
      }
      if (disabled) {
        wrapperClass = cx(wrapperClass, styles.disabled);
      }
      var errorStyles = error && styles.inputError;
      var focus = this.state.focus;
      var showError = shouldShowError && error;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(wrapperClass, styles.inputWrapper)
      }, shouldShowLabel && /*#__PURE__*/React.createElement(Label, {
        className: styles.label,
        required: required,
        showMandatoryIndicator: showMandatoryIndicator
      }, label), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.input, errorStyles, _defineProperty({}, styles.hasFocus, focus))
      }, /*#__PURE__*/React.createElement(RangePicker, _extends({
        defaultValue: [initialStartDate, initialEndDate],
        value: [startDate, endDate],
        format: dateFormat,
        placeholder: [__('Start date'), __('End date')],
        disabled: disabled
      }, rest))), showError && /*#__PURE__*/React.createElement("span", {
        className: styles.error
      }, error));
    }
  }]);
  return TDateInput;
}(React.PureComponent);
_defineProperty(TDateInput, "propTypes", {
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  shouldShowLabel: PropTypes.bool,
  shouldShowError: PropTypes.bool
});
_defineProperty(TDateInput, "defaultProps", {
  onFocus: _noop,
  onBlur: _noop,
  onChange: _noop,
  shouldShowLabel: true,
  shouldShowError: true
});
export default TDateInput;